<template>
  <div class="exam">
    <el-row>
      <el-col :span="24" class="topline">
        <div class="alignitems">
          <i class="el-icon-arrow-left backicon" @click="backlist"></i>
          <div id="box">
              <p><i class="el-icon-time"></i></p>
              <p>{{hour}}:{{minute}}:{{second}}</p>
          </div>
        </div>
        <div class="alignitems">
          <div class="fs">{{nowindex+1}}/{{subject_num}}</div>
        <!-- </div>
        <div class="alignitems"> -->
          <el-button class="btnsm"  @click="SubmitExam()">交卷 </el-button>
          <!-- <img class="fxicon" src="../common/imgs/fx03.png"  @click="fxexam" alt="">          -->
        </div>
      </el-col>
    </el-row>

    <el-row class="contant" v-if="current_subject">
      <el-col :span="24" >
          <div v-if="current_subject.subjectType=='1'" class="now_subject" >


            单选题
          </div>
          <div v-if="current_subject.subjectType=='2'" class="now_subject" >
            多选题
          </div>
          <div v-if="current_subject.subjectType=='3'" class="now_subject" >
            判断题
          </div>
      </el-col>

      <el-col :span="24">
           <!-- 当前题目 -->
          <div class="linh31" v-html="current_subject.subjectDes">
             {{current_subject.subjectDes}}
          </div>
      </el-col>

       <!-- 当前题目 -->
      <el-col :span="24"  v-if="current_subject.materialDecript">
        <div class="boxcard">
          <div class="linh31" v-html="current_subject.materialDecript">
             {{current_subject.materialDecript}}
          </div>
        </div>
      </el-col>

      <el-col :span="24" >
          <span class="ctitle" >
             哪个是正确答案？
          </span>
      </el-col>

      <el-col :span="24" >
          <!-- 当前选项>-->
          <div class="now_abcd"
               v-for="item,index in current_subject.selections"
               @click="event_choose_subject_item(item,index)"
               :class="{active:index==active}"
               :id="item.itemIndex">

            <div class="left_abcd">
              <span>{{item.itemIndex}} </span>
            </div>
            <div class="right_abcd" v-html="item.itemDecript">
              {{item.itemDecript}}
            </div>

          </div>
      </el-col>



      <el-col  :offset="2" :span="20" class=" hidediv hide mb5">
        <el-row>
          <el-col :span="11" class="center">
            <!-- <el-progress type="circle" class="circle" :percentage="bfbnum"></el-progress> -->
            <div data-v-49873ccf="" role="progressbar" aria-valuenow="37.33" aria-valuemin="0" aria-valuemax="100" class="el-progress circle el-progress--circle"><div class="el-progress-circle" style="height: 100px; width: 100px;"><svg viewBox="0 0 100 100"><path d="M 50 50 m 0 -47 a 47 47 0 1 1 0 94 a 47 47 0 1 1 0 -94" stroke="#e5e9f2" stroke-width="4.8" fill="none" class="el-progress-circle__track"></path><path d="M 50 50 m 0 -47 a 47 47 0 1 1 0 94 a 47 47 0 1 1 0 -94" stroke-linecap="round" stroke="#ffbc40" stroke-width="4.8" fill="none" class="el-progress-circle__path" style="stroke-dasharray: 299.08px, 299.08px; stroke-dashoffset: 187.433px; transition: stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease 0s;"></path></svg></div><div class="el-progress__text" style="font-size: 22px;">{{bfbnum}}%</div><div class="bottom__text" style="font-size: 12px;">正确率</div></div>
          </el-col>
          <el-col :span="12" class="nowap">
            <span class="dblck">本题已被做答
                <span class="yelab">{{current_subject.totalNum}}</span> 次
            </span>
            <span class="dblck">本题已有
                <span class="yelab">{{current_subject.rightNum}}</span>人做对
            </span>
            <span class="dblck" v-if="current_subject.confoundIndex">易错项为
                <span class="yelab">{{current_subject.confoundIndex}}</span>选项
            </span>
            <span class="dblck" v-if="!current_subject.confoundIndex">
                本题没有易错选项
            </span>
          </el-col>
        </el-row>
      </el-col>


      <!-- 解析 -->
      <el-col :span="24" class="hidediv hide">
          <div class="analysis linh31 f14"  v-html="current_subject.analysis">
              {{current_subject.analysis}}
          </div>
      </el-col>
       <el-col :span="24" class="hidediv hide">
          <div class="center downbtn">
            <button class="btndown mgauto">
              {{current_subject.exaPoint}}
            </button>
          </div>
          <div class="center ">
            <div class="subtitle mgauto">
                {{current_subject.source}}
            </div>
          </div>
      </el-col>
    </el-row>
    <!-- <div v-if="!current_subject"
            v-loading="loading"
            class="h100">
    </div> -->


  </div>
</template>

<script>
import { api_content_getexam } from "../../networks/DryRun.js"
import { api_content_subpostexam } from "../../networks/DryRun.js"
export default {
  name: 'exam',
  data () {
    return {
      loading: true, //
      userid:'',     //
      alltime:0,    //总时间
      ntime:1,       //初始计时
      hours:2,
      minutes:0,    //分钟
      seconds:0,     //秒
      nowindex:-1,   //当前页
      subject_num:'',     //总页
      subject_Exam:[],    //总数据
      itemDecriptList:[], //当前题目答案
      greenactive:-1,     //选对
      redactive:-1,       //选错
      active:-1,
      choseItem:'',       //自己选的答案
      postdata:{          //提交信息
        paperType:1,          //写1就行
        userid: '',          //用户iD
        submitType:1,         //写1就行
        paperId: '',          //试卷ID
        paperResult:{},       //题目具体信息
      },
      paperResult:{
        paperId: '',//试卷ID
        paperTypeId: '201607301639232601224301',//试卷类型
        answerInfo:[],
        remainTime:'',   //总消耗时间
      },
      answerInfo:[],
      PaperResultUserTime:[],
      // paperResult{ //题目具体信息
      //     paperId: '',//试卷ID
      //     paperTypeId: '201607301639232601224301',//试卷类型
      //     answerInfo[],
      //     remainTime:'',//总消耗时间
      //   },
      // answerInfo{//每道题的信息
      //          costTime: '',//消耗时间
      //          subjectId: '',//题目id
      //          choseItem: '',//选项id
      //          correctItem: '',//正确答案id
      //          section_code: '',//题目类型
      //          subjectIndex: '',//题目在试卷中的索引
      //   },
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    router_paperId() {//卷子id
      return this.$route.params.paperId
    },
    router_paperName() {//卷子name
      return this.$route.params.paperName
    },
    current_subject() {//当前页
      var subject = this.subject_Exam[this.nowindex];
      return subject;
    },
    second:function () {//倒计时
        return this.num(this.seconds)
    },
    minute:function () {//倒计时
        return this.num(this.minutes)
    },
    hour:function () {//倒计时
        return this.num(this.hours)
    },
    bfbnum:function () {//百分比
        var num= this.subject_Exam[this.nowindex].rightNum;
        var total= this.subject_Exam[this.nowindex].totalNum;
        var bfbnum = Math.round(num / total * 10000) / 100.00;
        return Math.round(bfbnum);
    },
  },
  watch:{
      second:{
          handler(newVal){
              this.num(newVal)
          }
      },
      minute:{
          handler(newVal){
              this.num(newVal)
          }
      },

  },

  created: function () {
    var context = this;
    context.user.user_id = '201903251533192368463451';
    if (!context.user.user_id || context.user.user_id == '') {
        context.$message({
          message: '请先登录',
          type: 'warning'
        });
        context.$router.push({ path: '/'});
        return;
    }
    else{
      var user_id = context.user.user_id;
      var paperId = context.router_paperId;


      context.postdata.paperResult.paperId = paperId;
      context.postdata.userid= user_id;

      context.subject_Exam=[];
      context.postdata.paperId= context.router_paperId;

      //1.请求网络层
      var promise = api_content_getexam(context,user_id,paperId);
      //2.更新返回数据
      promise.then(function(res) {
          for (var j = 0; j < res.examDetailInfo.length; j++) {
            context.subject_Exam.push(res.examDetailInfo[j]);
            context.answerInfo.push({});
            context.PaperResultUserTime.push({"start_time":0,"end_time":0,"use_time":0});
          }
          context.subject_num=res.subject_num; //题目总数
          //1.成功后更新当前题号
          context.nowindex = 0;
          var index = context.nowindex;
          //2.更新当前题号后自动更新 current_subject

          //3.第一题开始计时
          var timestamp=new Date().getTime();
          context.PaperResultUserTime[0]['start_time'] = timestamp;

          context.countdown();//开始倒计时
      }).catch(function(error){
      });
    }

  },
  destroyed: function() {
    //clearInterval(this.chat_timer);
  },
  methods: {
    event_choose_subject_item: function(item,index) {//点击选项
      var context = this;

      var timestamp=new Date().getTime();
      context.PaperResultUserTime[context.nowindex]['end_time'] = timestamp;
      //记录做题时长
      var stime = context.PaperResultUserTime[context.nowindex];
      context.PaperResultUserTime[context.nowindex]['use_time'] = stime['end_time'] - stime['start_time'];

      context.alltime=context.alltime+context.PaperResultUserTime[context.nowindex]['use_time']/1000;

      //context.choseItem=item.itemId;
      context.answerInfo[context.nowindex] = context.get_subject_data(item.itemId);

      context.active=index;
      setTimeout(function () { context.nextexam(); }, 100);
      // //单选
      // if (context.current_subject.correctIndexeList.indexOf(item.itemIndex)>=0){
      //   //1、选对
      //   context.greenactive=index;
      //   //2、延迟一秒跳转下一题
      //   setTimeout(function () { context.nextexam(); }, 800);
      // } else {
      //     //1、选错
      //     context.redactive=index;
      //     console.log(context.current_subject.correctIndex);
      //     $("#"+context.current_subject.correctIndex).addClass('greenactive');
      //     //2、显示解析
      //     context.show_right_analysis(index);
      // }


    },
    get_subject_data: function(itemId){
        var context = this;
        console.log("已作答做题时长"+ context.PaperResultUserTime[context.nowindex]['use_time']/1000);

        var nowData={
         costTime:  context.PaperResultUserTime[context.nowindex]['use_time']/1000,//消耗时间
         subjectId: context.current_subject.subjectId,//题目id
         choseItem: itemId,//学生选择的答案id
         correctItem: context.current_subject.correctItem,//正确答案id
         section_code: context.current_subject.section_code,//题目类型
         subjectIndex:  context.current_subject.subjectIndex,//题目在试卷中的索引
      };
      return nowData;
    },
    ////显示解析
    // show_right_analysis: function(index){
    //   var context = this;
    //   $(".hidediv").removeClass('hide');
    // },
    ////隐藏解析
    // hide_right_analysis: function(){
    //   var context = this;
    //   $(".greenactive").removeClass('greenactive');
    //   $(".hidediv").addClass('hide');
    // },

    backlist: function() {//退回首页
      var context = this;

      this.$confirm('确定不提交就返回吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           this.$router.push({ path: '/drymain'});
           clearInterval(this.chat_timer);
                 context.subject_Exam=[];
        }).catch(() => {

        });
      // context.$router.go(-1);

    },
    fxexam: function(){//分享
     if (window.__wxjs_environment === 'miniprogram') {
        var path = '../share/share?'+"&webViewUrl="+window.location.href;
        window.wx.miniProgram.navigateTo({
          url: path,
        });
      }
    },
    nextexam: function() {//下一题
      var context = this;
      var timestamp=new Date().getTime();
      context.PaperResultUserTime[context.nowindex+1]['start_time'] = timestamp;
      console.log("开始时间"+timestamp);

      //清除样式
      context.nowindex=context.nowindex+1;
      context.active=-1;
      //重新计时
      context.ntime=1;
      //context.hide_right_analysis();

    },
    num: function(n){  //倒计时
        return n<10 ? "0" + n : "" + n;
    },
    countdown :function () {  //倒计时
        var _this = this;
        var time = window.setInterval(function () {

            if (_this.seconds == '00' && _this.minutes != '00') {
                _this.seconds = 59;
                _this.minutes -= 1;
            }
            else if(_this.seconds == '00' && _this.minutes == '00' && _this.hours != '00'){
                _this.minutes = 60;
                _this.hours -= 1;
            }
            else if(_this.minutes == '00' && _this.seconds == '00'  && _this.hours == '0'){
                _this.seconds = 0;
                context.$message({
                  type: 'success',
                  message: '模考时间结束，自动交卷中···'
                });
                _this.SubmitExam();
                window.clearInterval(time);

            }else{
                _this.seconds -= 1
            }
        },1000);
    },
    SubmitExam :function () { //交卷
        var context = this;
         //保存当前页的题信息，最后

        for(var i=0;i<context.answerInfo.length;i++){
            var result = context.answerInfo[i];
            if($.isEmptyObject(result)){
                var current_subject = context.subject_Exam[i];
                var stime = context.PaperResultUserTime[i];
                var costTime = context.PaperResultUserTime[i]['use_time']/1000;

                var nowData = {
                   costTime: costTime,//消耗时间
                   subjectId: current_subject.subjectId,//题目id
                   choseItem: '',//选项id
                   correctItem: current_subject.correctItem,//正确答案id
                   section_code: current_subject.section_code,//题目类型
                   subjectIndex:  current_subject.subjectIndex,//题目在试卷中的索引
                };
                context.answerInfo[i] = nowData;
                var subTime = subTime + costTime;
            }
        }
        console.log(context.answerInfo);
        console.log(nowData);
        console.log(context.alltime);

        context.postdata.paperResult.remainTime=context.alltime;//总时间
        context.postdata.paperResult.paperTypeId ='201607301639232601224301';//id
        context.postdata.paperResult.paperName=context.current_subject.source;//name
        context.postdata.paperResult.answerInfo=context.answerInfo;
        //console.log("========题目具体信息=====");
        //console.log(context.postdata.paperResult);


        this.$confirm('确认交卷?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            var jsonStr = JSON.stringify(context.postdata.paperResult);
            console.log(jsonStr);
            //1.请求网络层
            var promise = api_content_subpostexam(context, jsonStr,context.user.user_id,context.router_paperId);
            //2.更新返回数据
            promise.then(function(json) {
                console.log("========交卷成功了吗!!!!!=====");
                console.log(json);
                if(json.data.code=='200'){
                  context.$message({
                    type: 'success',
                    message: '交卷成功!'
                  });
                  context.$router.push({ path: '/drymain' })
                  //json.data.result.paperName=context.router_paperName;
                  //json.data.result.paperId=context.router_paperId;
                  //context.$router.push({ name: 'testresults', params: { result: json.data.result }});
                }
            }).catch(function(error){
                console.error(error);
            });
        })



    },
  }
}
</script>

<style>

</style>

<style scoped>
.exam{
    width: 60%;
    margin: 0 auto;
}
.h100{
  min-height:676px;
  height:100%;
}
.topbtn{
    width: 100%;
    position: fixed;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content:space-between;
    background-color:#fff;
    right: 0px;
    bottom: 0px;
}
.btnsm{
    height: 30px;
    font-size: 12px;
    line-height: 4px;
    background-color: #ffbc40;
    color: #fff;
}
.fxicon{
      width: 25px;
    margin-left: 10px;
}
.topline{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:5px;
  right: 0px;
  top: 0px;
  z-index: 800;
  background-color:#fff;
}
.alignitems{
  display: flex;
   align-items: center;
}
.backicon{
  width:30px;
  height:30px;
  display: flex;
  align-items: center;
  justify-content: center;
      font-weight: 900;
}
.now_subject{
  margin-top:50px;
  margin-bottom:10px;
   color:#606266;
}
.contant{
  padding: 0 10px;
}

.ctitle{
    margin: 10px 0;
    font-size: 14px;
    color: #aaa;
}
.now_abcd{
    border: 1px solid #c0c4cc;
    border-radius: 9px;
    margin-bottom: 8px;
    display: flex;
    color:#606266;
    margin-top:10px;
}
.fs{
  color:#606266;
      margin-right: 10px;
    font-size: 14px;
}
.left_abcd{
    width: 30px;
    background-color: #ebeef5;
    border-top-left-radius:8px;
    border-bottom-left-radius:8px;
     display: flex;
     align-items: center;
     justify-content: center;
}
.right_abcd{
    padding-top: 7px;
    padding-bottom: 7px;
    padding-left: 11px;
}
.hide{
  display:none;
}
.active{
  background-color: #f9f9eb;
}
.active >.left_abcd{
  background-color: #f3d334;
  color: #fff;
}
.redactive{
  background-color: #FFBFBD;
}
.redactive >.left_abcd{
  background-color: #E26D4F;
  color: #fff;
}
.greenactive{
  background-color: #f0f9eb;
}
.greenactive >.left_abcd{
  background-color: #a1d64c;
  color: #fff;
}
.btndown{
    height: 30px;
    font-size: 12px;
    line-height: 5px;
    background-color: #fff;
        color: #606266;
}
.linh31{
  line-height:31px!important;
  overflow: scroll;
  color: #606266;
}
.center{
  display: flex;
}
.btnlg{
  margin: 10px auto;
  height: 46px;
  width: 150px;
  font-size: 16px;
  line-height: 5px;
  background-color: #ffbc40;
  color: #fff;
  border: 0px solid #dcdfe6;
}
.mgauto{
  margin: 10px auto;
}
.subtitle{
  font-size: 12px;
    color: #aaa;
    margin-top:10px;
    margin-bottom:40px;
}

.yelab{
  color: #fdbc3f;
}
.f14{
   font-size: 14px;
}
.dblck{
  display: block;
  font-size:14px;
  margin-top:12px;
      color: #606266;
}
#box{
  display: flex;
    border: 1px solid #eee;
    border-radius: 5px;
    font-size: 13px;
    margin-left: 10px;
    margin-right:10px;
    height: 25px;
    width:77px;
    color:#aaa;
      display: flex;
     align-items: center;
}
#box p{
  margin:5px;
}
.boxcard{
  background-color:#f5f5f5;
  padding:5px;
  height:150px;
  overflow:auto;
}
.downbtn{
    width: 50%;
    margin: 0px auto;
    border-top: 1px solid #eee;
}
.analysis{
  margin-bottom:5px;
}
.bottom__text{
    position: absolute;
    top: 67%;
    left: 0;
    width: 100%;
    text-align: center;
    margin: 0;
    -webkit-transform: translate(0,-50%);
    transform: translate(0,-50%);
}
.nowap{
  white-space:nowrap;
}
.mb5{
  margin-bottom:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/DryRun/Exam.vue